module.exports = __webpack_public_path__ + "img/home-background.77bd1ec0.jpg";